<template>
  <div class="xuanzejibenxinxi-page">

    <!-- 品牌头部 -->
    <header class="brand-header" aria-label="智能投顾">
      <div class="brand-mark" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>
      <div class="brand-name">{{ SystemName }}</div>
    </header>

    <div class="header">
      <h1>选择您的基本信息</h1>
      <p class="subtitle">为您提供更精准的风险评估与资产配置建议</p>
    </div>

    <div class="main-card">
      <div class="form-section">
        <div class="section-title">性别</div>
        <div class="gender-options">
          <div :class="['gender-item', { active: gender === 'male' }]" @click="gender = 'male'">
            <div class="gender-icon-wrapper male">
              <img src="@/assets/男士.png" alt="男" />
            </div>
            <span class="gender-text">男</span>
          </div>
          <div :class="['gender-item', { active: gender === 'female' }]" @click="gender = 'female'">
            <div class="gender-icon-wrapper female">
              <img src="@/assets/女士.png" alt="女" />
            </div>
            <span class="gender-text">女</span>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-title">年龄段</div>
        <div class="age-options">
          <div v-for="age in ageGroups" :key="age.value" :class="['age-item', { active: selectedAge === age.value }]"
               @click="selectedAge = age.value">
            {{ age.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button :class="['confirm-btn', { disabled: !isFormValid }]" id="btn-confirm-info" @click="handleConfirm">
        确认并继续
      </button>
      <div class="privacy-notice">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <span>您的信息仅用于生成个性化投资建议，将严格保密</span>
      </div>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import userManager from '@/utils/userManager'

export default {
  name: 'XuanzeJibenxinxiPage',
  data () {
    return {
      SystemName: window.SystemName,
      robotCode: window.robotCode,
      gender: '',
      selectedAge: '',
      ageGroups: [
        { value: 'under30', label: '30岁以下' },
        { value: '30-49', label: '30-49岁' },
        { value: '50-65', label: '50-65岁' },
        { value: 'over65', label: '65岁以上' }
      ]
    }
  },
  computed: {
    isFormValid () {
      return this.gender && this.selectedAge
    }
  },
  watch: {
    gender (newVal) {
      localStorage.setItem('currentSelection', JSON.stringify({ gender: newVal, selectedAge: this.selectedAge }))
    },
    selectedAge (newVal) {
      localStorage.setItem('currentSelection', JSON.stringify({ gender: this.gender, selectedAge: newVal }))
    }
  },
  mounted () {
    // 监听其他标签页的 localStorage 变化
    window.addEventListener('storage', this.handleStorageChange)
    // 初始化时检查是否有已保存的选择
    const saved = localStorage.getItem('currentSelection')
    if (saved) {
      try {
        const data = JSON.parse(saved)
        this.gender = data.gender || ''
        this.selectedAge = data.selectedAge || ''
      } catch (e) {
        console.error('Failed to parse saved selection:', e)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange (event) {
      if (event.key === 'currentSelection' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          if (data.gender !== this.gender) {
            this.gender = data.gender
          }
          if (data.selectedAge !== this.selectedAge) {
            this.selectedAge = data.selectedAge
          }
        } catch (e) {
          console.error('Failed to parse storage change:', e)
        }
      }
    },
    handleConfirm () {
      if (!this.isFormValid) return
      localStorage.setItem('basicInfo', JSON.stringify({
        gender: this.gender,
        age: this.selectedAge
      }))
      this.Login(this.gender, this.selectedAge)
    },

    // 调用登录接口
    Login (gender, age) {
      const genderCode = gender === 'male' || gender === '男' ? 1 : 0
      //年龄根据选的范围，进行随机数生成
      let ageCode = 0
      if (age === 'under30') {
        ageCode = Math.floor(Math.random() * 12) + 18
      } else if (age === '30-49') {
        ageCode = Math.floor(Math.random() * 19) + 30 + 1
      } else if (age === '50-65') {
        ageCode = Math.floor(Math.random() * 15) + 50 + 1
      } else if (age === 'over65') {
        ageCode = Math.floor(Math.random() * 15) + 65 + 1
      }

      apiOpen
        .RobotLogin({
          robotCode: this.robotCode,
          gender: genderCode,
          // age: typeof age === 'number' ? age : parseInt(age) || 0
          age: ageCode
        })
        .then(res => {
          userManager.setToken(res.accessToken)
          sessionStorage.setItem('lastloginTime', this.formatTimeStamp())
          sessionStorage.setItem('loginLogId', JSON.stringify(res.loginLogId))
          localStorage.setItem('loginLogId', JSON.stringify(res.loginLogId))
          setTimeout(() => {
            this.$router.push({ name: 'Shibie' })
          }, 300)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
  }
}
</script>

<style scoped lang="less">
.xuanzejibenxinxi-page {
  min-height: 100vh;
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 78px 60px 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.brand-header {
  position: fixed;
  top: 26px;
  left: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 100;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
}

.brand-mark i {
  display: block;
  width: 7px;
  border-radius: 8px;
  background: linear-gradient(180deg, #1768ff, #6c55ff);
  box-shadow: 0 4px 12px rgba(42, 91, 255, 0.22);
}

.brand-mark i:nth-child(1) {
  height: 18px;
}

.brand-mark i:nth-child(2) {
  height: 29px;
}

.brand-mark i:nth-child(3) {
  height: 38px;
}

.brand-mark i:nth-child(4) {
  height: 25px;
}

.brand-mark i:nth-child(5) {
  height: 12px;
}

.brand-name {
  color: #0d2148;
  font-size: 1.48rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px 0;
}

.subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

.main-card {
  background: white;
  border-radius: 24px;
  padding: 20px 40px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 36px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
}

.gender-options {
  display: flex;
  gap: 16px;
}

.gender-item {
  flex: 1;
  padding: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.gender-item:hover {
  border-color: #cbd5e1;
}

.gender-item.active {
  border-color: #3b82f6;
  background: #eff6ff;
}

.gender-item.active.female {
  border-color: #ec4899;
  background: #fdf2f8;
}

.gender-icon-wrapper {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.gender-icon-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gender-icon-wrapper.male {
  background: #dbeafe;
}

.gender-icon-wrapper.female {
  background: #fecdd3;
}

.gender-text {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.age-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.age-item {
  padding: 14px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.age-item:hover {
  border-color: #cbd5e1;
}

.age-item.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.footer {
  width: 100%;
  max-width: 520px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.confirm-btn {
  width: 100%;
  padding: 16px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
}

.confirm-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
}

.confirm-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.privacy-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #94a3b8;
}

.privacy-notice svg {
  color: #3b82f6;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .xuanzejibenxinxi-page {
    padding: 80px 24px 32px;
  }

  .header h1 {
    font-size: 26px;
  }

  .subtitle {
    font-size: 14px;
  }

  .main-card {
    padding: 28px;
    border-radius: 20px;
  }

  .gender-item {
    padding: 16px;
  }

  .gender-icon-wrapper {
    width: 44px;
    height: 44px;
  }

  .age-item {
    padding: 12px 8px;
    font-size: 13px;
  }

  .confirm-btn {
    padding: 14px;
    font-size: 16px;
    display: none;
  }
}

@media (max-width: 480px) {
  .xuanzejibenxinxi-page {
    padding: 100px 16px 24px;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    justify-content: flex-start;
  }

  .brand-header {
    top: 16px;
    left: 16px;
  }

  .brand-mark {
    height: 28px;
    gap: 3px;
  }

  .brand-mark i {
    width: 5px;
  }

  .brand-mark i:nth-child(1) {
    height: 14px;
  }

  .brand-mark i:nth-child(2) {
    height: 22px;
  }

  .brand-mark i:nth-child(3) {
    height: 28px;
  }

  .brand-mark i:nth-child(4) {
    height: 19px;
  }

  .brand-mark i:nth-child(5) {
    height: 9px;
  }

  .brand-name {
    font-size: 1.1rem;
  }

  .header {
    margin-bottom: 24px;
  }

  .header h1 {
    font-size: 22px;
  }

  .subtitle {
    font-size: 13px;
  }

  .main-card {
    padding: 20px;
    border-radius: 16px;
  }

  .form-section {
    margin-bottom: 24px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .gender-options {
    gap: 12px;
  }

  .gender-item {
    padding: 12px 8px;
    border-radius: 12px;
    gap: 8px;
  }

  .gender-icon-wrapper {
    width: 38px;
    height: 38px;
  }

  .gender-text {
    font-size: 14px;
  }

  .age-options {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .age-item {
    padding: 10px 8px;
    font-size: 13px;
    border-radius: 10px;
  }

  .footer {
    margin-top: 24px;
  }

  .confirm-btn {
    padding: 13px;
    font-size: 15px;
    border-radius: 10px;
  }

  .privacy-notice {
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .xuanzejibenxinxi-page {
    padding: 90px 12px 20px;
  }

  .header {
    margin-bottom: 20px;
  }

  .header h1 {
    font-size: 20px;
  }

  .main-card {
    padding: 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .gender-options {
    gap: 10px;
  }

  .gender-item {
    padding: 10px 6px;
    gap: 6px;
  }

  .gender-icon-wrapper {
    width: 34px;
    height: 34px;
  }

  .gender-text {
    font-size: 13px;
  }

  .age-options {
    gap: 6px;
  }

  .age-item {
    padding: 9px 6px;
    font-size: 12px;
  }

  .footer {
    margin-top: 20px;
  }

  .confirm-btn {
    padding: 12px;
    font-size: 14px;
  }

  .privacy-notice {
    font-size: 11px;
  }
}
</style>